import React, { useEffect, useState } from 'react';
import { Avatar, Modal, Select } from 'antd';
import { connect, useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import getUserId from '../../shared/core/GetToken';
import Settings from '../../shared/config/Settings';
import { ActivityIndicator, View } from 'react-native-web';
import { appServices } from '../../shared/redux/actions/appServices';
import getUserInfo from '../../shared/core/GetTokenized';
const MyCareTeam = (props) => {

  const information =  getUserInfo(); // Get the user info (will resolve the promise)
  const PatienInformation = JSON.parse(information);
  React.useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://indici-pre-production.web.app/assets/js/template.js";
    document.body.appendChild(script)
    // d.div.appendChild(script);
  }, [])
  // const { Profile } = props.Profile;
  const {Profile}= useSelector((state)=> state.PatientProfile)
  const [frontState, setFrontState] = React.useState(false);
  const openMenu = () => {
    var element = document.getElementById("myphonemenu");

    setFrontState(frontState => !frontState);
    setFrontState((state) => {
      state ? element.classList.add("sidebar-collpased") : element.classList.remove("sidebar-collpased");
      return state;
    });
  }
  const [bioModalVissible, setBioModalVissible] = useState(false)
  const [centersArray, setCentersArray] = useState([]);
  const [selectedData, setSelectedData] = useState(null)
  const [centerLoading, setCenterLoading] = useState(false)
  const [selectedCenter, setSelectedCenter] = useState()
  const [CarerTeamList, setCarerTeamList] = React.useState([])
  const [isLoading, setLoading] = React.useState(false)
  const { LocationData, isLocation } = useSelector((state)=>state.Location);
  const {StaffProfileData , isStaffProfileLoading} = useSelector((state)=>state.StaffProfile)
  const dispatch= useDispatch();
  const locObject={
    TypeID:1,
    PatientID: Profile && Profile[0].resource.id
   }
  const getCarerTeamList = () => {

  }
  useEffect(() => {
    if(selectedCenter){
    let practID = Profile && Profile[0]?.resource?.extension[16]?.valueString
    const payload= {
      PatientID : Profile[0].resource.id,
      PracticeLocationID :  selectedCenter ? selectedCenter  : practID
    }
    // var requestOptions = {
    //   method: 'GET',
    //   redirect: 'follow'
    // };
    setLoading(true)
    dispatch(appServices.StaffProfile(payload))
  }
    // getUserId().then((userInfo) => {
    //   //setPdfViewerLoading(true)
    //   const item = JSON.parse(userInfo);
    //   let url = selectedCenter ? "&PracticeLocationID=" + selectedCenter : "&PracticeLocationID=" + practID
    //   fetch(Settings.apiUrl + "/Patient/StaffProfile?Token=" + item.token + "&PatientID=" + item.userid + url, requestOptions)
    //     .then(data => data.json())
    //     .then(json => {
    //       console.log("JSON", json[0].entry)
    //       setCarerTeamList(json[0]?.entry)
    //       setLoading(false)
    //     })
    //     .catch(error => {
    //       console.log("error")
    //       setLoading(false)
    //     })
    //     .finally(() => {
    //       console.log("error")
    //       setLoading(false)
    //     });
    // });
  }, [selectedCenter])
  useEffect(() => {
    // CallcenterList()
   if(Profile) dispatch(appServices.Location(locObject))
  }, [Profile])
  useEffect(() => {
  if(StaffProfileData){
    setCarerTeamList(StaffProfileData[0]?.entry)
    setLoading(false)
  }
  }, [StaffProfileData])
  
  useEffect(() => {
    if(LocationData){
        let ob;
        let newarr = []
        // console.log("Center arrray",arr)
        LocationData.map((entry, item) => (
            ob = {
                name: entry?.resource?.name,
                id: entry?.resource?.identifier[0]?.value
            },
            newarr.push(ob)
        ))
        console.log("Center arrray", newarr)
        setCentersArray(newarr)
        setSelectedCenter(newarr[0]?.id)
        // setMoveDayLookup(medicationsDays != undefined ? getOptionsArray(medicationsDays, 'DayName', 'TreatmentDaysID') : [])
        // setCentersArray(newarr)
        // getOptionsArray(newarr)

        // setCentersArray(json[0].entry)
        setCenterLoading(false)  
    }
}, [LocationData])

  const CallcenterList = () => {

    // setProviderArray([]);
    getUserId().then((userInfo) => {

      const item = JSON.parse(userInfo);
      var myHeaders = new Headers();
      setCenterLoading(true)
      myHeaders.append("Token", item.token);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      const queryString = '?Token=' + item.token + '&PatientID=' + item.userid + '&TypeID=1';
      fetch(Settings.apiUrl + "Patient/Location" + queryString, requestOptions)

        .then(data => data.json())
        .then(json => {
          let ob;
          let newarr = []
          json[0].entry.map((entry, item) => (
            ob = {
              name: entry?.resource?.name,
              id: entry?.resource?.identifier[0]?.value
            },
            newarr.push(ob)
          ))
          console.log("Center arrray", newarr)
          setCentersArray(newarr)
          setCenterLoading(false)
        })
        .catch(err => {
          setCenterLoading(false)
        })
    })
  }

  return (
    <div>
      {/* {typeof (Allergies == !undefined) && Allergies.length && console.log(JSON.stringify(Allergies))} */}
      {/* <Header onClick={() => openMenu()} />
      <div id="myphonemenu" className="page-body">

        <Sidebar /> */}



        <div className="page-content-wrapper">
          <div className="page-content-wrapper-inner">
            <div className="viewport-header">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb has-arrow">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">My Care Team</li>
                </ol>
              </nav>
            </div>

            <label className="label" style={{ width: 130 }}>Selected Center</label>
            {centersArray && centersArray.length ?
              <div className="col-md-6">
                <Select
                  defaultValue={centersArray[0]?.id}
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Select a person"
                  optionFilterProp="children"
                  onChange={(res) => {
                    setSelectedCenter(res)
                  }}
                  value={selectedCenter}
                >
                  {
                    centersArray.map((item, index) => <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>)
                  }

                </Select>
              </div>
              : !centerLoading &&
              <p>No registered Role Available.</p>
            }
            <div className="content-viewport">



              {
                isLoading && <View style={{ textAlign: 'center', marginTop: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
              }

              {centerLoading ?
                null
                :
                <div id="cards_landscape_wrap-2">




                  <div className="row" id="cards_landscape_wrap-2" style={{ marginTop: 25 }}>

                    {CarerTeamList?.map((team, index) => (
                      <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                        <a href>
                          <div className="card-flyer">
                            <div className="text-box">
                              <div className='card-top-border'>

                              </div>
                              <div className='icon-box'>
                                <div className='icon-class green-color'>
                                  <i className="fa fa-check-circle" aria-hidden="true"></i>
                                </div>

                              </div>
                              <div className="image-box">
                                <img className='rounded-circle' src={team?.resource?.extension[3]?.url == "ProviderPicture" ? `data:image/png;base64,${team?.resource.extension[3]?.valueString}` : 'data:image/jpeg;base64,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'} alt />
                              </div>
                              <div className="text-container">
                                <h6>{team?.resource.name[0]?.text}</h6>
                                {/* {team?.resource?.extension[2]?.url == "ProviderRelationship" ? <p>Relationship: {team?.resource?.extension[2]?.valueString} </p> : <p>Relationship: N/A</p>}
                                {team?.resource?.extension[3]?.url == "ProviderLocation" ? <p>Location: {team?.resource?.extension[3]?.valueString} </p> : <p>Location: N/A</p>} */}
                                <div>
                                  <div>
                                    {team?.resource?.extension[6]?.url == "BioNotes" ? <button style={{ marginTop: 10 }} className="btn btn-primary" onClick={() => {
                                      setSelectedData(team)
                                      setBioModalVissible(true)
                                      //

                                    }}>See Bio</button> : null}

                                  </div>

                                </div>

                              </div>

                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              }








            </div>
          </div>

          <footer className="footer">

          </footer>
        </div>

      {/* </div> */}
      <Modal
        title="Bio Notes"
        centered
        open={bioModalVissible}
        closable={false}
        onOk={() => {
          setBioModalVissible(false);

        }}
        // loading={loading}
        onCancel={() => setBioModalVissible(false)}
        style={{ top: 10, bottom: 90, overflow: "hidden" }}
        width={1000}
      // footer={[
      //     isSending ?
      //         <ActivityIndicator size="small" color="#00A1DE" />

      //         :
      //         <>
      //             <Button key="back" onClick={() => setNewMsgModal(false)}>
      //                 Cancel
      //             </Button>
      //             <Button key="submit" type="secondary" onClick={() => saveDraft()}>
      //                 Draft
      //             </Button>
      //             <Button key="submit" type="primary" onClick={() => sendMessage()}>
      //                 Send
      //             </Button>
      //         </>


      // ]}
      >
        <div className="row" >
          <div className="col-md-12 mx-auto">
            {/* <div className="col-md-12 mx-auto">
              <div className="alert alert-warning" role="alert">

                <h6 className="alert-heading">Bio Notes:</h6>


              </div>
            </div> */}

            <div style={{}} className="form-group row mb-0">
              {selectedData?.resource?.extension[6]?.url == "BioNotes" ? <p> {selectedData?.resource?.extension[6]?.valueString} </p> : <p>Bio Notes: N/A</p>}

            </div>




            {/* <div style={{ alignItems: 'flex-end', backgroundColor: 'red' }} className="form-group row mb-0">

                        </div> */}

          </div>


        </div>

      </Modal>
    </div>
  )
}


// function mapStateToProps(state) {
//   return {
//     // Reports: state.Reports,
//     Profile: state.Profile,
//   }
// }

// function mapDispatchToProps(disptach) {
//   return {
//     // getReports: (pageSize, pageNumber) => disptach(fetchReportsFromApi(pageSize, pageNumber)),
//     //  getMoreReports: (token, pageSize, pageNumber) => disptach(fetchMoreReportsFromApi(token, pageSize, pageNumber))
//   }
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(MyCareTeam)
export default MyCareTeam;
